// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3LYcT","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__j1tEq"};